/**
 * Promo trailer content puzzle — fixed published board (Medium 9×9).
 * Same as /puzzle/play-jigsaw/{storyId}/board/{jigsawId}
 * Play: /puzzle/play-jigsaw/e4481732-cd06-4ccb-93ea-365c7a939540/board/b421151c-891a-4b64-95af-8967a3659eea
 */
export const RECORDING_CONTENT_STORY_ID = "e4481732-cd06-4ccb-93ea-365c7a939540";
/** Trailer grid: Medium = 9×9. Resolve by tile size when template lookup is available. */
export const RECORDING_CONTENT_GRID = 9;
/** The Medium (9×9) template on the story above — used when the template lookup fails. */
export const RECORDING_CONTENT_JIGSAW_ID = "b421151c-891a-4b64-95af-8967a3659eea";
